import {Wrapper} from "@/components/molecules/expandButton/ExpandButton.styled"
import {ButtonWithIcon} from "@/components/molecules";

export const ExpandButton = (props: any) => {
  const {isSpread, setIsSpread} = props;

  const handleClick = () => {
    setIsSpread((isSpread: boolean) => !isSpread);
  }

    return (
        <Wrapper>
            <ButtonWithIcon
                onClick={handleClick}
                textLevel={8}
                iconName={isSpread ? 'chevronUp' : 'chevronDown'}
            >
                {isSpread? '모아보기' : '펼쳐보기'}
            </ButtonWithIcon>
        </Wrapper>
    );
};
 export default  ExpandButton
